import { Link } from "react-router-dom";
import { button } from "./ui/primitives";

export function NotFoundPage() {
	return (
		<section className="mx-auto max-w-[560px] pt-20 pb-6">
			<div
				aria-hidden="true"
				className="mb-[18px] text-[120px] font-black leading-[.9] tracking-[-.02em] text-transparent [font-stretch:125%] [-webkit-text-stroke:1.5px_var(--color-line-3)]"
			>
				404
			</div>
			<h1 className="m-0 mb-2.5 text-[28px] font-extrabold [font-stretch:112%]">This page isn&apos;t on the map.</h1>
			<p className="m-0 mb-6 text-[15px] leading-relaxed text-ink-2">The link may be old or mistyped. Search for a summoner instead.</p>
			<Link to="/" className={button.primary + " hover:text-on-signal"}>
				Back to search
			</Link>
		</section>
	);
}
